import { Modal } from "antd";
import { observer } from "mobx-react";
import { IMPREZA_BUTTON_PROPS, __ } from "../../../../utils";
import { ChangePlanForm } from ".";
const ChangePlanModal = observer(_ref => {
  let {
    record,
    visible,
    onClose
  } = _ref;
  const {
    data: {
      id
    }
  } = record;
  return /*#__PURE__*/React.createElement(Modal, {
    open: visible,
    title: __("Change plan"),
    cancelText: __("Cancel"),
    okText: __("Change plan with payment obligation"),
    onCancel: onClose,
    okButtonProps: {
      form: `change-plan-form-${id}`,
      htmlType: "submit",
      ...IMPREZA_BUTTON_PROPS
    },
    style: {
      minWidth: 700
    }
  }, /*#__PURE__*/React.createElement(ChangePlanForm, {
    record: record,
    onSave: onClose
  }));
});
export { ChangePlanModal };